export const SettingNameEnum = Object.freeze({
	PLAN_ID_MONTHLY: "planIdMonthly",
	PLAN_ID_YEARLY: "planIdYearly",
	PRICE_YEARLY: "priceYearly",
	PRICE_MONTHLY: "priceMonthly",
	SHOW_STUDENT_ENROLLMENT: "showStudentEnrollment",
	EXTRA_MESSAGE: "extraMessage",
})
